<template>
<div class="sidebar-container">

    <div id="sidebar" class="sidebar" :class="openNav ? 'block': ''">

        <div class="notifications-center" v-if="showNotis">
            <div class="content">
                <div class="top">
                    <div class="logo">activity</div>
                    <div class="notification-icon active" @click="openNotis()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11.891" height="11.891" viewBox="0 0 23.781 23.781">
                          <path class="fill-white" d="M382.829,147l8.485,8.485a2,2,0,0,1-2.829,2.829L380,149.829l-8.485,8.485a2,2,0,0,1-2.829-2.829L377.172,147l-8.486-8.485a2,2,0,0,1,2.829-2.829L380,144.172l8.485-8.486a2,2,0,0,1,2.829,2.829Z" transform="translate(-368.125 -135.125)"/>
                        </svg>
                    </div>
                </div>
                <div class="notifications">
                    <ul>
                        <li>
                            <div class="dot new"></div>
                            <div class="item">
                                <p>John Smith screening is complete & ready to view</p>
                                <p class="date">4 minutes ago</p>
                            </div>
                        </li>
                        <li>
                            <div class="dot new"></div>
                            <div class="item">
                                <p>John Smith screening is complete & ready to view</p>
                                <p class="date">30 minutes ago</p>
                            </div>
                        </li>
                        <li>
                            <div class="dot"></div>
                            <div class="item">
                                <p>John Smith screening is complete & ready to view</p>
                                <p class="date">4 days ago</p>
                            </div>
                        </li>
                        <li>
                            <div class="dot"></div>
                            <div class="item">
                                <p>John Smith screening is complete & ready to view</p>
                                <p class="date">28/03/2018</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <button class="transparent clear">{{ $t('button.clearall') }}</button>
            </div>
        </div>

        <div class="content">
            <div class="top">
                <router-link to="/" class="logo">
                    <logo></logo>
                </router-link>
                <div class="lang-switcher">
                    <select v-model="language">
                        <option value="dk">Da</option>
                        <option value="en">Eng</option>
                    </select>
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 20 11.97">
                          <path class="fill-purple" d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z" transform="translate(-3241 -2084.03)"/>
                        </svg>
                    </span>
                </div>
            </div>

            <landlord-navigation v-if="getTenantAccess === null"></landlord-navigation>
            <tenant-navigation v-else></tenant-navigation>

            <div class="bottom" @click="openNavigation">
                <div class="user">
                    <div>
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17.984" height="18" viewBox="0 0 35.969 36">
                              <path class="fill-dark-grey" d="M102,297a4,4,0,1,0-4-4A4,4,0,0,0,102,297Zm5.04,2.211,2.02,2.02,7.523,2.3a2,2,0,0,1,1.393,1.619l2,13.556a2,2,0,0,1-1.686,2.271A2.038,2.038,0,0,1,118,321H86.01a2,2,0,0,1-1.98-2.29l1.992-13.554a2,2,0,0,1,1.224-1.562l6-2.446a2,2,0,0,1,1.508,3.7l-4.94,2.014L88.324,317H115.68l-1.48-10.012-6.79-2.077a1.987,1.987,0,0,1-.828-0.5l-3.488-3.488a8,8,0,1,1,3.944-1.712h0Z" transform="translate(-84 -285)"/>
                            </svg>
                        </div>
                        <p class="name">
                            {{$t('sidebar.nav.profile')}}
                            <!-- {{getFullNameOrEmail}} -->
                        </p>
                        <!-- <p>Company name</p> -->
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="user-nav" id="user-nav" v-if="showNav">
            <div class="section">
                <ul>
                    <li><router-link to="/user/settings" @click.native="showNav = false">{{ $t('sidebar.nav.settings') }}</router-link></li>
                </ul>
            </div>
            <div class="section">
                <ul>
                    <li><a @click.prevent="logout">{{ $t('sidebar.nav.logout') }}</a></li>
                </ul>
            </div>
        </div>
<div v-if="showNav" @click="closeNavigation" class="nav-overlay"></div>
</div>
</template>

<script>
    import LandlordNavigation from './navigations/LandlordNavigation';
    import TenantNavigation from './navigations/TenantNavigation';
    import Logo from './Logo';
    import {mapGetters} from 'vuex'
    import {store} from "../store";
    import Vue from "vue";

    export default {
        data: () => ({
            language: 'dk',
            showNav: false,
            showNotis: false,
            openNav: false,
        }),
        mounted() {
            const storedLanguage = window.localStorage.getItem('language');

            if (storedLanguage !== null) {
                this.language = storedLanguage;
            }

            Vue.i18n.set(this.language);

            this.languageChangedEvent = new Event('language-change');
        },
        methods:{
            logout(){
                store.dispatch('logout').then(
                    () => {
                        store.dispatch('resetDraftContractsStates');
                        this.$router.push('/login')
                    }
                );
            },
            openNavigation: function(){

                this.showNav = !this.showNav
            },
            closeNavigation: function(){

                this.showNav = !this.showNav
            },
            openNotis: function(){
                this.showNotis = !this.showNotis
            },
            toggleNav: function() {
                // this.openNav = !this.openNav
                $('#sidebar').toggleClass('block');
                $('.toggle-nav').toggleClass('open');
            }
        },
        computed:{
            ...mapGetters([
                'getFullName',
                'getUserImage',
                'getFullNameOrEmail',
                'getLanguage',
                'getTenantAccess'
            ])
        },
        components:{
            LandlordNavigation,
            TenantNavigation,
            Logo
        },
        watch: {
            '$route' () {
                //$('#sidebar').addClass('hide');
                $('#sidebar').removeClass('block');

                //$('.toggle-nav').addClass('closed');
                $('.toggle-nav').removeClass('open');
            },

            language(val) {
                this.$i18n.set(val);
                window.localStorage.setItem('language', val);
                window.document.dispatchEvent(this.languageChangedEvent);
            }
        }

    }
</script>
